//var CallHeader   = require('CallHeader');
//var UserSession = require('UserSession');
//var userSessions = require('UserSessions');
var $            = global.jQuery;
var ajax         = require('AjaxHelpers');
var helpers      = require('Helpers');


var SyncService = {

     loadGalleryDetails: function (params) {

        return ajax.GetDeferred('gallery', 'loadGalleryDetails', ajax.ObjectToQueryString(params));
    },

    loadGalleryFilters: function (params) {

        return ajax.GetDeferred('gallery', 'loadFilters', ajax.ObjectToQueryString(params));
    },

    loadMapping: function (params) {

        return ajax.GetDeferred('gallery', 'loadMapping', ajax.ObjectToQueryString(params));
    },

    findPictures: function (params, filterData) {

        return ajax.PostDeferred('gallery', 'find', '?' + ajax.ObjectToQueryString(params), filterData);
    },

     prepareBulkPictureExport: function (params, downloadRequest) {

        return ajax.PostDeferred('gallery', 'prepareBulkPictureExport', '?' + ajax.ObjectToQueryString(params), downloadRequest);
    },

    prepareBulkPictureStatusChange: function (params, statusChangeRequest) {

        return ajax.PostDeferred('gallery', 'bulksetapprovalstatus', '?' + ajax.ObjectToQueryString(params), statusChangeRequest);
    },
    
    downloadpictureexportfile: function (params) {
        $.ajaxSettings.traditional = true;
        var url = helpers.format('gallery/downloadpictureexportfile?{0}', ajax.ObjectToQueryString(params));
      return $.fileDownload(global.apiEndpoint + url, { httpMethod: "GET"});
        //return ajax.PostDeferred('gallery', 'getPictures', '?' + ajax.ObjectToQueryString(params), pictureIds);
    },

    authenticateUser: function (data) {

        //fake = { Content: { SessionToken: "f80ccb44-db9c-4f6e-901e-7b0220891433", CreatedOn: "2016-10-05T16:56:25", ExpiresOn: "2016-10-05T19:08:45", RenewableOn: "2016-10-05T18:08:45" } }
        //return $.Deferred().resolve(fake);

        var requestData = {
            Email           : data.UserName,
            Password        : data.Password,
            DeviceIdentifier: 'InBrowser'
        };

        return ajax.PostDeferred('Authentication', 'AuthenticateUser', null, requestData);

    },
    Version: "V0.1",

    getSessionData: function (params) {

        return ajax.GetDeferred('authentication', 'getSessionData', ajax.ObjectToQueryString(params));
    },

    getIndividualCall: function (params) {

       console.error('getindividualcall', params, ajax.ObjectToQueryString(params));
       return ajax.GetDeferred('sync', 'getindividualcall', ajax.ObjectToQueryString(params));

    },

    getQuestionnaire: function (params) {

        return ajax.GetDeferred('sync', 'getquestionnairedetails', ajax.ObjectToQueryString(params));
    },

     downloadAnswerFile: function (params) {

        return ajax.GetDeferred('sync', 'getbase64encodedanswerFile', ajax.ObjectToQueryString(params));
    },

    uploadAnswerFiles: function (params, answerFileData) {

        return ajax.PostDeferred('sync', 'UploadBase64EncodedAnswerFiles', '?' + ajax.ObjectToQueryString(params), answerFileData);
    },

     sync: function (params, syncRequest) {

        return ajax.PostDeferred('sync', 'Sync', '?' + ajax.ObjectToQueryString(params), syncRequest);
    },

}

module.exports = SyncService;

